import React, { useMemo, useState } from "react";
import { Box, Flex, Select, Text } from "@chakra-ui/react";
import { MockQuestion, QuestionType } from "../../../../types/reading-types";
import { shuffleOptions } from "../../../../utils/helperFuntions";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { UserAnswerSchema, userAnswerSchema } from "../schema";
import { useAnswerStore } from "../../../../redux/zustand-store";

type StaticSentenceProps = {
  userId: string;
  question: MockQuestion;
  isDisplayOptions?: boolean;
  questionType?: QuestionType;
};

export const StaticSentence: React.FC<StaticSentenceProps> = ({
  userId,
  question,
  isDisplayOptions = true,
  questionType,
}) => {
  const { responses, addResponse, updateResponse } = useAnswerStore();
  const { handleSubmit, setValue } = useForm({
    resolver: yupResolver(userAnswerSchema),
  });

  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  const options = useMemo(() => {
    let optionsArray = [
      question.correctAnswer,
      question.optionB,
      question.optionC,
      question.optionD,
      question.optionE ?? "",
    ];
    if (questionType === "ReadingForInformation") {
      optionsArray.sort();
    } else {
      optionsArray = shuffleOptions(optionsArray);
    }
    return optionsArray;
  }, [question, questionType]);

  const onSubmit = (data: UserAnswerSchema) => {

    const existingResponse = responses.find(
      (response) =>
        response.userId === userId &&
        response.question === question.question,
    );
    

    if (existingResponse) {
      updateResponse(userId, question.question, data.userAnswer);
    } else {
      addResponse({
        userId,
        question: question.question,
        userAnswer: data.userAnswer,
        correctAnswer: question.correctAnswer,
        questionType: questionType || "",
      });
    }
  };

  const handleChange = (value: string) => {
    setSelectedOption(value);
    setValue("userAnswer", value);
    handleSubmit(onSubmit)();
  };

  return (
    <Box p={1} mt={-5}>
      <Flex p={3}>
        {questionType !== "ReadingForInformation" ? (
          <Text mb={2} mr={1} fontSize={14}>
            {question.question}
          </Text>
        ) : (
          ""
        )}
        {isDisplayOptions ? (
          <Select
            placeholder=" "
            maxW={questionType === "ReadingForInformation" ? 65 : selectedOption ? 130 : 90}
            fontSize={12}
            h={7}
            borderRadius={"sm"}
            bg={"#FFF"}
            style={{
              color: selectedOption ? "green" : "black",
            }}
            onChange={(e) => handleChange(e.target.value)}
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
          >
            {options.map((option, index) => (
              <option
                key={index}
                value={option}
              >
                {option}
              </option>
            ))}
          </Select>
        ) : (
          ""
        )}
        {questionType === "ReadingForInformation" ? (
          <Text mb={2} ml={1} fontSize={14}>
            {question.question}
          </Text>
        ) : (
          ""
        )}
      </Flex>
    </Box>
  );
};
